import React, { useState } from "react";
import { MessageCircle, Send } from "lucide-react";
import AdminLayout from "../../Components/Layout/AdminLayout";
import { PageHeader, ThemePanel } from "../../Components/Layout/ThemeElements";
import { getPgSettings, getWhatsAppMessages, saveWhatsAppMessages, todayISO } from "../../Utils/pgRequirementStore";

const templates = [
    "Admission form link",
    "Admission confirmation",
    "Payment receipt",
    "Rent reminder",
    "Late payment alert",
    "Renewal confirmation",
];

const WhatsAppAutomation = () => {
    const [messages, setMessages] = useState(getWhatsAppMessages());
    const [form, setForm] = useState({ student: "", phone: "", template: "Payment receipt", message: "" });
    const settings = getPgSettings();

    const sendMessage = (event) => {
        event.preventDefault();
        const next = [...messages, { ...form, id: Date.now(), date: todayISO(), provider: settings.whatsappProvider, status: "Queued" }];
        setMessages(next);
        saveWhatsAppMessages(next);
        setForm({ student: "", phone: "", template: "Payment receipt", message: "" });
    };

    return (
        <AdminLayout>
            <div className="space-y-6">
                <PageHeader eyebrow="Automation" title="WhatsApp Automation" description="Prepare Twilio or Meta WhatsApp Business API messages for admissions, payments, reminders, and renewals." />
                <div className="grid gap-6 xl:grid-cols-[0.8fr_1.2fr]">
                    <ThemePanel title="Queue WhatsApp Message" description={`Current provider: ${settings.whatsappProvider}`}>
                        <form className="space-y-4" onSubmit={sendMessage}>
                            <input className="pg-input" placeholder="Student name" value={form.student} onChange={(event) => setForm({ ...form, student: event.target.value })} required />
                            <input className="pg-input" placeholder="WhatsApp phone" value={form.phone} onChange={(event) => setForm({ ...form, phone: event.target.value })} required />
                            <select className="pg-input" value={form.template} onChange={(event) => setForm({ ...form, template: event.target.value })}>
                                {templates.map((template) => <option key={template}>{template}</option>)}
                            </select>
                            <textarea className="pg-input" rows="4" placeholder={settings.receiptTemplate} value={form.message} onChange={(event) => setForm({ ...form, message: event.target.value })} />
                            <button className="pg-button-primary w-full" type="submit"><Send size={18} /> Queue Message</button>
                        </form>
                    </ThemePanel>
                    <ThemePanel title="Message History" description="Backend API can consume these queued messages for actual delivery.">
                        <div className="space-y-3">
                            {messages.map((item) => (
                                <div className="rounded-lg border p-4" key={item.id}>
                                    <div className="flex items-start gap-3">
                                        <span className="pg-icon-button"><MessageCircle size={17} /></span>
                                        <div>
                                            <p className="font-bold text-slate-900">{item.template} · {item.student}</p>
                                            <p className="text-sm text-slate-500">{item.phone} · {item.provider} · {item.status}</p>
                                            <p className="mt-2 text-sm">{item.message || "Template message will be generated by API."}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {!messages.length && <p className="text-slate-500">No messages queued yet.</p>}
                        </div>
                    </ThemePanel>
                </div>
            </div>
        </AdminLayout>
    );
};

export default WhatsAppAutomation;
